import 'angular';

import '../../app-lite/quickbooks/quickbooks.module.ajs';

import { ExportQBCtrl }           from './quickbooks.export-qb';
import { QuickbooksStates }       from './quickbooks.states.ajs';
import { QuickbooksSettingsCtrl } from './quickbooks.settings';

angular.module('workshop.quickbooks', [
  'app-lite.quickbooks'
])
.config(QuickbooksStates)
.controller('ExportQBCtrl', ExportQBCtrl)
.controller('QuickbooksSettingsCtrl', QuickbooksSettingsCtrl);
